import { customIcons as icons } from "~/ui";

interface SearchInputProps {
  handleOnSubmit: React.FormEventHandler<HTMLFormElement>;
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string;
}

export const SearchInput = ({
  search,
  setSearch,
  handleOnSubmit,
  placeholder,
}: SearchInputProps) => {
  return (
    <form className="flex max-w-sm items-center" onSubmit={handleOnSubmit}>
      <label htmlFor="simple-search" className="sr-only">
        Search
      </label>
      <div className="relative w-full">
        <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-2">
          <icons.SearchIcon />
        </div>
        <input
          type="text"
          className="text-indigo focus:ring-violet focus:border-violet shadow-2xs block w-[350px] rounded-md border border-[#E0E0E0] bg-white px-2.5 py-4 ps-12 font-sans text-[16px]"
          placeholder={placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    </form>
  );
};
